import { useState, useCallback, useMemo } from "react";
import { CategorizationRule } from "@/services/categorization-rules";

export function useCategorizationRuleModal() {
  const [showModal, setShowModal] = useState(false);
  const [editingRule, setEditingRule] = useState<
    CategorizationRule | undefined
  >();

  // Accept optional namePattern, category, and ruleName arguments
  const openCreateModal = useCallback(
    (namePattern?: string, category?: string, ruleName?: string) => {
      setEditingRule({
        name: ruleName || "",
        description: "",
        namePattern: namePattern || "",
        amountMin: null,
        amountMax: null,
        amountExact: null,
        category: category || "",
        priority: 0,
        isActive: true,
        id: "",
        organizationId: "",
        userId: "",
        createdAt: new Date(),
        updatedAt: new Date(),
      });
      setShowModal(true);
    },
    [],
  );

  const openEditModal = useCallback((rule: CategorizationRule) => {
    setEditingRule(rule);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setEditingRule(undefined);
  }, []);

  const modalProps = useMemo(
    () => ({
      showModal,
      setShowModal,
      editingRule,
      isEditing: !!editingRule,
    }),
    [showModal, editingRule],
  );

  return {
    openCreateModal,
    openEditModal,
    closeModal,
    modalProps,
  };
}
